import { getURLParam } from 'js/utils/url.util';

export const markMenuItemAsOpener = (chatWidget, inboxWidget) => (menuItems) => menuItems.map((item) => ({
    ...item,
    inboxOpener: inboxWidget && inboxWidget.enabled && inboxWidget.counterPage === item.url,
    chatOpener: chatWidget && chatWidget.enabled && chatWidget.counterPage === item.url
}));

export const getMenuSiblingsByUrl = (url) => (items) => {
    for (const item of items) {
        if (item.friendlyURL === url) {
            return items;
        } else if (item.children) {
            const found = getMenuSiblingsByUrl(url)(item.children);

            if (found) {
                return found;
            }
        }
    }
};

export const filterByUrlAvailability = (search) => (menuItems) => {
    const hideChatByUrl = getURLParam(search, 'hideChat') === '1';
    const hideInboxByUrl = getURLParam(search, 'hideInbox') === '1';

    return menuItems.filter((item) => {
        if (item.inboxOpener) {
            return !hideInboxByUrl;
        }

        if (item.chatOpener) {
            return !hideChatByUrl;
        }

        if (item.children) {
            filterByUrlAvailability(search)(item.children);
        }

        return true;
    });
};
